import React from 'react';
import { Box, Button } from '@material-ui/core';
import { Tooltip } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import InfoCirclePurple from 'assets/icons/info-circle-purple.svg';
import Img from 'retired/Img';
import { ModalTitle, ModalTypography } from 'components/Modal/Modal';
import { ModalStep } from 'components/Flow/components/ModalStep';
import { DeedHeartHands } from 'components/Flow/components/DeedHeartHands';
import { StepComponentProps } from 'components/Flow/RenderMachine';
import { NonprofitEntityType } from 'entities/organization/model';

export const PayPalWelcome = ({
  isTransitionAllowed,
  send,
  state,
}: StepComponentProps): JSX.Element => {
  const isSchool = state?.context?.nonprofit?.nonprofitEntityType === NonprofitEntityType.school;
  const isNon501c3 = [NonprofitEntityType.school, NonprofitEntityType.governmentEntity].includes(
    state?.context?.nonprofit?.nonprofitEntityType
  );
  return (
    <ModalStep
      showHelpCenterLink={!isSchool}
      showProgressBar
      actions={
        <div>
          {isTransitionAllowed('SKIP') && (
            <Button
              color="inherit"
              type="button"
              endIcon={<ArrowForwardIcon style={{ fontSize: 16 }} />}
              style={{ marginRight: 8 }}
              onClick={(): unknown => send('SKIP')}
            >
              Skip
            </Button>
          )}
          {isSchool && (
            <Button
              type="button"
              style={{ marginRight: 8 }}
              onClick={(): unknown => send('NO_PPB')}
            >
              I cannot verify with PayPal
            </Button>
          )}
          <Button type="button" variant="contained" onClick={(): void => send('SUBMIT')}>
            Complete User Verification
          </Button>
        </div>
      }
      header={<DeedHeartHands />}
      headerStyles={{
        paddingTop: 16,
      }}
    >
      <Box mb={4}>
        <ModalTitle size="large">Welcome to Deed!</ModalTitle>
        <ModalTypography>
          Your home for corporate giving, volunteering, and relationship-building! Let&apos;s get
          you set up starting with user verification.
        </ModalTypography>

        <ModalTitle>
          Complete User Verification{' '}
          <Tooltip
            placement="right"
            title="We’ve partnered with PayPal to ensure a secure and reliable verification process. When prompted to verify your profile, you’ll be redirected to PayPal’s website, a trusted platform, where you can securely enter the account owner’s credentials. Your privacy and security are our top priorities"
          >
            <span style={{ display: 'inline-block', marginLeft: 4, transform: 'translateY(-2px)' }}>
              <Img
                src={InfoCirclePurple}
                style={{
                  height: 'max-content',
                }}
              />
            </span>
          </Tooltip>
        </ModalTitle>
        {isNon501c3 ? (
          <>
            <ModalTypography>
              To claim your profile, you will need to complete User Verification. We have provided 2
              options to verify individuals associated with your organization.
            </ModalTypography>
            <ul style={{ paddingLeft: 12 }}>
              <li>
                <ModalTypography>
                  <b>Verify with PayPal</b> using a PayPal Business account with the organization’s
                  name (preferred);
                </ModalTypography>
              </li>
              <li>
                <ModalTypography>
                  <b>I cannot verify with PayPal</b>. You will be asked to provide a voided check or
                  bank letter to verify your association to the organization.
                </ModalTypography>
              </li>
            </ul>
            <ModalTypography>Select the best option for your organization below.</ModalTypography>
          </>
        ) : (
          <>
            <ModalTypography>
              For <b>User Verification</b>, Deed works in partnership with <b>PayPal</b> to verify
              both organizations and the individuals associated with those organizations.
              <br />
              Your organization is already enrolled with PayPal Giving Fund! Please use the Verify
              button below to connect your Deed and PayPal accounts.
            </ModalTypography>
            <ModalTypography>
              Please note that <b>users can only verify themselves</b> using the{' '}
              <b>account owner credentials</b> for a{' '}
              <b>PayPal business account of your organization.</b>
            </ModalTypography>
          </>
        )}
      </Box>
    </ModalStep>
  );
};
